import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import miscFunctions from '../helpers/misc-functions';
import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';
import DataModel from '../models/DataModel';

const closeoutsBaseURI = '/closeouts';

const defaultRequestHeaders = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
  'Expires': '0',
  'Content-Type': 'application/json',
  'Accept': '*/*',
};

function createDateTimeStamp(){
  return Math.round(new Date().getTime()/1000.0);
}

function createOffSetTimezone(){
  let offset = new Date().getTimezoneOffset() / 60 * 100;
  let offsetString;
  if(offset < 0){
    offsetString = '+';
  }
  else{
    offsetString = '-';
  }
  if(offset.toString().length > 3){
    offsetString += offset;
  }
  else{
    offsetString += `0${offset}`;
  }
  return offsetString;
}

function createCloseout(closeoutableTypeAndId, eventMetadatum) {

  let date = createDateTimeStamp();
  let timezone = null;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    // ignore...
  }
  let offset = createOffSetTimezone();
  let data = closeoutableTypeAndId;
  data.closeout_date = date;
  if (timezone) {
    data.timezone = timezone;
  } else {
    data.offset = offset;
  }
  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }
  data.event_metadatum = eventMetadatum;

  return axios({
    method: 'post',
    url:
      process.env.REACT_APP_API + 
      closeoutsBaseURI + 
      '?current_company=' + localStorage.current_company_id,
    timeout: 20000,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
    data: data,
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}

function getCloseout(closeoutId, options) {
  let url = process.env.REACT_APP_API + '/closeouts/'+closeoutId+'?current_company='+localStorage.current_company_id;
  if (options && options.recordDescriptor){
    url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
  }
  return axios({
    method: 'get',
    url: url,
    timeout: 20000, headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      'Authorization': 'Token token=' + localStorage.token,
    },
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error };
    });
}

function getCloseoutSnapShot(closeoutableTypeAndId) {

  let date = createDateTimeStamp();
  let timezone = null;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    // ignore...
  }
  let offset = createOffSetTimezone();
  let data = closeoutableTypeAndId;
  data.closeout_date = date;
  if (timezone) {
    data.timezone = timezone;
  } else {
    data.offset = offset;
  }

  return axios({
    method: 'post',
    url:
      process.env.REACT_APP_API + 
      closeoutsBaseURI + 
      '/closeout_snapshot?current_company=' + localStorage.current_company_id,
    timeout: 20000,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
    data: data,
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}

function updateCloseout(closeout, regenerate, eventMetadatum) {
  let date = createDateTimeStamp();
  let offset = (new Date().getTimezoneOffset() * 60 * 1000);
  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }

  return axios({
    method: 'patch',
    url:
      process.env.REACT_APP_API + 
      closeoutsBaseURI + 
      '/' + closeout.id + 
      '?current_company=' + localStorage.current_company_id,
    timeout: 20000,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
    data: {
      event_metadatum: eventMetadatum,
      closeout: closeout,
      regenerate,
      closeout_date: date,
      offset,
    },
  })
    .then(response => {
      return miscFunctions.mapApiJson(response.data);
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}

function deleteCloseout(closeoutId, projectId, eventMetadatum) {
  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }
  return axios({
    method: 'delete',
    url:
      process.env.REACT_APP_API + 
      closeoutsBaseURI + '/' + closeoutId + '/' +
      '?current_company=' + localStorage.current_company_id,
    timeout: 20000,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
    data: {
      event_metadatum: eventMetadatum,
      project_id: projectId,
    },
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}

function searchCloseoutSummary(searchString, filter = null, user_id, page, perPage, company_id, options) {
  let url = process.env.REACT_APP_API + closeoutsBaseURI + '/closeout_summary?current_company=' +
    (company_id ? company_id : localStorage.current_company_id);

  if (!miscFunctions.isEmpty(filter)) {
    if (filter.sortField) {
      url += '&order=' + filter.sortField + (filter.ascending ? ',asc' : ',desc');
    }
    if(filter.project_types && filter.project_types.length > 0){
      let projectTypes = '&project_type_id=' + filter.project_types.map(pt => { return (pt.id);}).join(',');
      url += projectTypes;
    }
    if (filter.project_managers && filter.project_managers.length > 0) {
      let projectManagers = '&project_manager_id=' + filter.project_managers.map(pm => { return pm.id ? pm.id : pm; }).join(',');
      url += projectManagers;
    }
    if (filter.statuses && filter.statuses.length > 0) {
      let status = '&status=' + filter.statuses.map(status => { return status; }).join(',');
      url += status;
    }
    if (filter.types && filter.types.length > 0) {
      let type = '&closeoutable_type=' + filter.types.map(type => { return type; }).join(',');
      url += type;
    }
    if (filter.closeout_users && filter.closeout_users.length > 0) {
      let closeoutUsers = '&user_id=' + filter.closeout_users.map(cu => { return cu.id ? cu.id : cu; }).join(',');
      url += closeoutUsers;
    }
    if (filter.startDate && filter.endDate) {
      url += filter.startDate ? `&start_date=${filter.startDate}` : '';
      url += filter.endDate ? `&end_date=${filter.endDate}` : '';
    }
  }

  return axios({
    method: 'get',
    url: url,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}

function emailCloseouts(CloseoutIds, UserIds) {

  let url = process.env.REACT_APP_API + closeoutsBaseURI + '/send_email?current_company=' + localStorage.current_company_id
    + '&closeout_ids=' + CloseoutIds + '&user_ids=' + UserIds; 

  return axios({
    method: 'post',
    url: url,
    timeout: 20000,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
  })
    .then(response => {
      DataModel.displayInfoErrorMessage(response.data.message, 4000, 1);
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}

function getZipCloseout(zipLink, zip_file_name, company_id) {
  let url;
  if(zipLink){
    url = zipLink.replace(/&token=.*?(?=&|$)/, '');
  }

  return axios({
    method: 'get',
    url: url,
    timeout: 20000,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
  })
    .then(response => {
      DataModel.displayInfoErrorMessage(response.data.message, 4000, 1);
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}

export default {
  createCloseout,
  getCloseout,
  getCloseoutSnapShot,
  updateCloseout,
  deleteCloseout,
  searchCloseoutSummary,
  emailCloseouts,
  getZipCloseout,
};



// WEBPACK FOOTER //
// ./src/services/closeoutsService.js